module.exports = __webpack_public_path__ + "static/img/资讯.675f359.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/新建文件夹/资讯.png
// module id = Y0UR
// module chunks = 192